import { useState, type FormEvent } from "react";
import { ArrowRight, CheckCircle2, Clock3, MapPin } from "lucide-react";

import { BrandMark } from "../components/BrandMark";
import { PasswordField } from "../components/PasswordField";

type LoginPageProps = {
  onLogin: (credentials: { email: string; password: string }) => Promise<unknown>;
  loading: boolean;
  error: string | null;
};

export function LoginPage({ onLogin, loading, error }: LoginPageProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    await onLogin({ email, password });
  }

  return (
    <main className="login-page">
      <section className="login-intro">
        <BrandMark />
        <div className="login-intro__message">
          <p className="eyebrow">Lavori sul campo, ordinati</p>
          <h1>Dal primo ingresso<br />all’ultimo attrezzo.</h1>
          <p>Interventi, ore, collaboratori e foto aggiornati nello stesso posto, mentre il lavoro succede.</p>
        </div>
        <ul className="login-benefits" aria-label="Funzioni principali">
          <li><Clock3 size={20} /> Ore precise, senza fogli volanti</li>
          <li><MapPin size={20} /> Strutture e incarichi sempre chiari</li>
          <li><CheckCircle2 size={20} /> Titolare e squadra sincronizzati</li>
        </ul>
      </section>

      <section className="login-panel">
        <div className="login-card">
          <p className="eyebrow">Bentornato</p>
          <h2>Entra nella tua squadra</h2>
          <form onSubmit={submit}>
            <label>
              <span>Email</span>
              <input type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
            </label>
            <PasswordField
              label="Password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            {error && <p className="form-error" role="alert">{error}</p>}
            <button className="button button--primary button--wide" type="submit" disabled={loading}>
              {loading ? "Accesso in corso..." : "Entra in MANUTIO"} <ArrowRight size={19} />
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}
